"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useTypewriter_1 = require("./useTypewriter");
exports.default = useTypewriter_1.default;
//# sourceMappingURL=index.js.map